export default {
  nav: {
    home: "Home",
    services: "Services",
    contacts: "Contacts",
  },
  actions: {
    book: "Book a visit",
    call: "Call",
    route: "Get directions",
    allServices: "All services",
  },
};
